module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New Product","input-1":"Name","input-2":"Color","input-3":"Price","input-4":"SKU","create":"Create product"},"pt-BR":{"title":"Novo Produto","input-1":"Nome","input-2":"Cor","input-3":"Preço","input-4":"SKU","create":"Criar produto"}}')
  delete Component.options._Ctor
}
